import React from 'react';
import { Mail, Twitter, Linkedin, ExternalLink } from 'lucide-react';

/**
 * VINTAGE FOOTER COMPONENT - ENHANCED WITH PROPER SOCIAL LINKS
 * 
 * Design Philosophy: Classic academic paper footer with social integration
 * - Clean social media links
 * - Professional contact information
 * - Vintage typography and spacing
 */

const VintageFooter = ({ profileData }) => {
  if (!profileData) return null;

  return (
    <footer className="bg-vintage-paper mt-16" style={{ borderTop: '2px solid #8b4513' }}>
      <div className="max-w-6xl mx-auto px-6 py-12">
        
        {/* Main Footer Content */}
        <div className="text-center">
          
          {/* Profile Quote/Bio */}
          <div className="vintage-quote mb-8 max-w-3xl mx-auto">
            {profileData.bio}
          </div>

          {/* Social Links - Enhanced with proper icons */}
          <div className="mb-8">
            <h3 className="vintage-heading-3 text-vintage-ink mb-6">Connect</h3>
            <div className="flex items-center justify-center space-x-8">
              
              {/* Email */}
              {profileData.email && (
                <a 
                  href={`mailto:${profileData.email}`}
                  className="vintage-link text-vintage-ink hover:text-vintage-accent transition-colors flex items-center space-x-2 p-3 rounded-xl hover:bg-vintage-cream"
                >
                  <Mail size={20} />
                  <span className="typewriter text-sm font-medium">Email</span>
                </a>
              )}
              
              {/* LinkedIn */}
              {profileData.social?.linkedin && (
                <a 
                  href={profileData.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vintage-link text-vintage-ink hover:text-vintage-accent transition-colors flex items-center space-x-2 p-3 rounded-xl hover:bg-vintage-cream"
                >
                  <Linkedin size={20} />
                  <span className="typewriter text-sm font-medium">LinkedIn</span>
                </a>
              )}
              
              {/* Twitter/X */}
              {profileData.social?.twitter && (
                <a 
                  href={profileData.social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vintage-link text-vintage-ink hover:text-vintage-accent transition-colors flex items-center space-x-2 p-3 rounded-xl hover:bg-vintage-cream"
                >
                  <Twitter size={20} />
                  <span className="typewriter text-sm font-medium">Twitter</span>
                </a>
              )}
              
              {/* Substack */}
              {profileData.social?.substack && (
                <a 
                  href={profileData.social.substack}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vintage-link text-vintage-ink hover:text-vintage-accent transition-colors flex items-center space-x-2 p-3 rounded-xl hover:bg-vintage-cream"
                >
                  <ExternalLink size={20} />
                  <span className="typewriter text-sm font-medium">Substack</span>
                </a>
              )}
            </div>
          </div>

          {/* Professional Links */}
          <div className="mb-8">
            <div className="flex items-center justify-center space-x-8 text-sm">
              <a href="/about" className="vintage-link text-vintage-faded hover:text-vintage-accent transition-colors">About</a>
              <a href="/blog" className="vintage-link text-vintage-faded hover:text-vintage-accent transition-colors">Essays</a>
              <a href="/initiatives" className="vintage-link text-vintage-faded hover:text-vintage-accent transition-colors">Initiatives</a>
              <a href="/contact" className="vintage-link text-vintage-faded hover:text-vintage-accent transition-colors">Contact</a>
            </div>
          </div>

          {/* Copyright Section */}
          <hr className="vintage-divider" />
          
          <div className="space-y-2">
            <div className="vintage-caption text-vintage-faded">
              © {new Date().getFullYear()} {profileData.name}. All rights reserved.
            </div>
            
            <div className="vintage-caption text-vintage-muted italic">
              Built with care for optimal readability and user experience.
            </div>
          </div>
          
        </div>
      </div>
    </footer>
  );
};

export default VintageFooter;